export default __webpack_public_path__ + "static/pay-it-faster-video-thumbnail@2x-aa4e1ba223e9aaa989868cc1edf7453e.png";